import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';

const View = ({ data }) => {
  const { title, align = 'center', titleLink } = data;

  if (!title) return null;

  const hasLink = titleLink?.length > 0;

  const content = (
    <ConditionalLink item={titleLink?.[0]} condition={hasLink}>
      {title}
    </ConditionalLink>
  );

  const hClass = cx(`sectionTitle text-${align}`, {
    'text-interactive': hasLink,
  });

  return <h2 className={hClass}>{content}</h2>;
};

export default View;
